import { createContext, useReducer, useCallback } from "react";

import axios from "../../utils/axios/v1/userAxios";

const GET_CUSTOMRULES = "GET_CUSTOMRULES";
const GET_CURRENT_CUSTOM_RULE = "GET_CURRENT_CUSTOM_RULE";
const GET_RULES = "GET_RULES";
const SELECT_RULE = "SELECT_RULE";
const GET_SD_SIG_RULES = "GET_SD_SIG_RULES";
const SELECT_SD_SIG_RULE = "SELECT_SD_SIG_RULE";
const GET_WAF_CONFIG = "GET_WAF_CONFIG";

const GET_ALL_EXCEPTION = "GET_ALL_EXCEPTION";
const GET_RULES_FOR_EXCEPTION = "GET_RULES_FOR_EXCEPTION";
const GET_ALL_CRS_SEC_RULES = "GET_ALL_CRS_SEC_RULES";
const GET_ALL_SD_SEC_RULES = "GET_ALL_SD_SEC_RULES";
const GET_SINGLE_EXCEPTION = "GET_SINGLE_EXCEPTION";
const CLEAR_CUSTOM_RULES = "CLEAR_CUSTOM_RULES";
const CLEAR_EXCEPTIONS = "CLEAR_EXCEPTIONS";

const SET_ERROR = "SET_ERROR";

const normalizeWafConfig = (data) => {
  if (!data || typeof data !== "object") return data;
  return {
    ...data,
    active: data.active,
    sd_sig_module_active: data.sdSigModuleActive ?? data.sd_sig_module_active,
    smart_parse_module_active: data.smartParseModuleActive ?? data.smart_parse_module_active,
    signature_module_active: data.signatureModuleActive ?? data.signature_module_active,
    smart_parse_sensitivity: data.smartParseSensitivity ?? data.smart_parse_sensitivity,
    use_cache: data.useCache ?? data.use_cache,
    waf_action_sig: data.wafActionSig ?? data.waf_action_sig,
    waf_action_sd_sig: data.wafActionSdSig ?? data.waf_action_sd_sig,
    waf_action_smart_parse: data.wafActionSmartParse ?? data.waf_action_smart_parse,
    signature_waf_level: data.signatureWafLevel ?? data.signature_waf_level,
    waf_challenge_kind_sd_sig: data.wafChallengeKindSdSig ?? data.waf_challenge_kind_sd_sig ?? null,
    waf_challenge_kind_smart_parse: data.wafChallengeKindSmartParse ?? data.waf_challenge_kind_smart_parse ?? null,
    paranoia_level: data.paranoiaLevel ?? data.paranoia_level,
    anomaly_scoring: data.anomalyScoring ?? data.anomaly_scoring,
    block_page: data.blockPage ?? data.block_page,
    audit_req_body: data.auditReqBody ?? data.audit_req_body,
    created_date: data.createdDate ?? data.created_date,
    updated_at: data.updatedAt ?? data.updated_at,
  };
};

const normalizeSecRule = (rule) => {
  if (!rule || typeof rule !== "object") return rule;
  const secRuleId = rule.secRuleId ?? rule.sec_rule_id;
  const ruleId = rule.ruleId ?? rule.rule_id;
  return {
    ...rule,
    sec_rule_id: secRuleId != null ? String(secRuleId) : undefined,
    rule_id: ruleId != null ? String(ruleId) : undefined,
    description: rule.description,
    enabled: rule.enabled,
    tags: rule.tags,
  };
};

const normalizeRuleGroup = (data) => {
  if (!data || typeof data !== "object") return data;
  if (Array.isArray(data)) {
    return data.map((item) => normalizeRuleGroup(item));
  }
  const crsSecRules = data.crsSecRules ?? data.crs_sec_rules;
  return {
    ...data,
    rule_id: (data.ruleId ?? data.rule_id) != null ? String(data.ruleId ?? data.rule_id) : undefined,
    name: data.name,
    description: data.description,
    enabled: data.enabled,
    crs_sec_rules: Array.isArray(crsSecRules) ? crsSecRules.map(normalizeSecRule) : crsSecRules,
  };
};

const normalizeCustomRule = (data) => {
  if (!data || typeof data !== "object") return data;
  if (Array.isArray(data)) {
    return data.map((item) => normalizeCustomRule(item));
  }
  return {
    ...data,
    custom_rule_id: (data.customRuleId ?? data.custom_rule_id) != null ? String(data.customRuleId ?? data.custom_rule_id) : undefined,
    description: data.description,
    action: data.action,
    conditions: data.conditions,
    created_date: data.createdDate ?? data.created_date,
  };
};

const initialState = {
  customRules: null,
  curCustomRule: null,
  crsrules: null,
  currule: null,
  sdSigRules: null,
  curSdSigRule: null,
  wafConfig: null,
  exceptions: null,
  rulesForException: null,
  curexception: null,
  allCrsSecRules: null,
  allSdSecRules: null,

  errMsg: null,
};

const WAFRuleReducer = (state, action) => {
  switch (action.type) {
    case GET_CUSTOMRULES:
      return {
        ...state,
        customRules: action.payload.customRules,
      };
    case GET_CURRENT_CUSTOM_RULE:
      return {
        ...state,
        curCustomRule: action.payload.curCustomRule,
      };
    case GET_RULES:
      return {
        ...state,
        crsrules: action.payload.crsrules,
      };
    case SELECT_RULE:
      return {
        ...state,
        currule: action.payload.currule,
      };
    case GET_SD_SIG_RULES:
      return {
        ...state,
        sdSigRules: action.payload.sdSigRules,
      };
    case SELECT_SD_SIG_RULE:
      return {
        ...state,
        curSdSigRule: action.payload.curSdSigRule,
      };
    case GET_WAF_CONFIG:
      return {
        ...state,
        wafConfig: action.payload.wafConfig,
      };
    case GET_ALL_EXCEPTION:
      return {
        ...state,
        exceptions: action.payload.exceptions,
      };
    case GET_RULES_FOR_EXCEPTION:
      return {
        ...state,
        rulesForException: action.payload.rulesForException,
      };
    case GET_ALL_CRS_SEC_RULES:
      return {
        ...state,
        allCrsSecRules: action.payload.allCrsSecRules,
      };
    case GET_ALL_SD_SEC_RULES:
      return {
        ...state,
        allSdSecRules: action.payload.allSdSecRules,
      };
    case GET_SINGLE_EXCEPTION:
      return {
        ...state,
        curexception: action.payload.curexception,
      };
    case CLEAR_CUSTOM_RULES:
      return {
        ...state,
        customRules: null,
      };
    case CLEAR_EXCEPTIONS:
      return {
        ...state,
        exceptions: null,
      };
    case SET_ERROR:
      return {
        ...state,
        errMsg: action.payload.errMsg,
      };
    default:
      return state;
  }
};

const WAFConfigContext = createContext(null);

function WAFRuleProvider({ children }) {
  const [state, dispatch] = useReducer(WAFRuleReducer, initialState);

  const setErr = useCallback((msg) => {
    dispatch({
      type: SET_ERROR,
      payload: {
        errMsg: msg,
      },
    });
  }, []);
  const setWAFConfig = useCallback((wafConfig) => {
    dispatch({
      type: GET_WAF_CONFIG,
      payload: {
        wafConfig: normalizeWafConfig(wafConfig),
      },
    });
  }, []);
  const clearCustomRules = useCallback(() => {
    dispatch({ type: CLEAR_CUSTOM_RULES });
  }, []);
  const clearExceptions = useCallback(() => {
    dispatch({ type: CLEAR_EXCEPTIONS });
  }, []);
  const getCustomRules = useCallback(async () => {
    dispatch({
      type: GET_CUSTOMRULES,
      payload: {
        customRules: null,
      },
    });
    try {
      const response = await axios.get("config/rule/custom");
      dispatch({
        type: GET_CUSTOMRULES,
        payload: {
          customRules: normalizeCustomRule(response.data),
        },
      });
    } catch (err) {
      dispatch({
        type: GET_CUSTOMRULES,
        payload: {
          customRules: [],
        },
      });
      setErr(err.message);
    }
  }, [setErr]);

  const createCustomRule = useCallback(
    async (values) => {
      try {
        await axios.post("config/rule/custom", values);
        getCustomRules();
        return { msg: "Success", status: "success" };
      } catch (err) {
        const error_msg = err.message;
        setErr(error_msg);
        getCustomRules();
        return { msg: error_msg, status: "error" };
      }
    },
    [getCustomRules, setErr]
  );

  const updateCustomRule = useCallback(
    async (ruleID, values) => {
      try {
        await axios.patch(`config/rule/custom/${ruleID}`, values);
        getCustomRules();
        return { msg: "Success", status: "success" };
      } catch (err) {
        const error_msg = err.message;
        setErr(error_msg);
        getCustomRules();
        return { msg: error_msg, status: "error" };
      }
    },
    [getCustomRules, setErr]
  );

  const deleteCustomRule = useCallback(
    async (ruleID) => {
      try {
        await axios.delete(`config/rule/custom/${ruleID}`);
        getCustomRules();
      } catch (err) {
        setErr(err.message);
      }
    },
    [getCustomRules, setErr]
  );
  const getCustomRule = useCallback(
    async (ruleID) => {
      dispatch({
        type: GET_CURRENT_CUSTOM_RULE,
        payload: {
          curCustomRule: null,
        },
      });
      try {
        const response = await axios.get(`config/rule/custom/${ruleID}`);
        const normalized = normalizeCustomRule(response.data);
        dispatch({
          type: GET_CURRENT_CUSTOM_RULE,
          payload: {
            curCustomRule: normalized,
          },
        });
        return normalized;
      } catch (err) {
        dispatch({
          type: GET_CURRENT_CUSTOM_RULE,
          payload: {
            curCustomRule: [],
          },
        });
        setErr(err.message);
        return null;
      }
    },
    [setErr]
  );

  const getRules = useCallback(async () => {
    dispatch({
      type: GET_RULES,
      payload: {
        crsrules: null,
      },
    });
    try {
      const response = await axios.get("/config/rule/crsrule");
      dispatch({
        type: GET_RULES,
        payload: {
          crsrules: normalizeRuleGroup(response.data),
        },
      });
    } catch (err) {
      dispatch({
        type: GET_RULES,
        payload: {
          crsrules: [],
        },
      });
      setErr(err.message);
    }
  }, [setErr]);

  const selectCurrentRule = useCallback(
    async (ruleID, siteUid, init = true) => {
      if (init) {
        dispatch({
          type: SELECT_RULE,
          payload: {
            currule: null,
          },
        });
        setErr(null);
      }
      try {
        const response = await axios.get(`/config/waf/${siteUid}/crs_rule/${ruleID}`);
        dispatch({
          type: SELECT_RULE,
          payload: {
            currule: normalizeRuleGroup(response.data),
          },
        });
      } catch (err) {
        dispatch({
          type: SELECT_RULE,
          payload: {
            currule: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr]
  );

  const getSdSigRules = useCallback(async () => {
    dispatch({
      type: GET_SD_SIG_RULES,
      payload: {
        sdSigRules: null,
      },
    });
    try {
      const response = await axios.get("/config/rule/sd_sig_rule");
      dispatch({
        type: GET_SD_SIG_RULES,
        payload: {
          sdSigRules: normalizeRuleGroup(response.data),
        },
      });
    } catch (err) {
      dispatch({
        type: GET_SD_SIG_RULES,
        payload: {
          sdSigRules: [],
        },
      });
      setErr(err.message);
    }
  }, [setErr]);

  const selectCurrentSdSigRule = useCallback(
    async (ruleID, siteUid, init = true) => {
      if (init) {
        dispatch({
          type: SELECT_SD_SIG_RULE,
          payload: {
            curSdSigRule: null,
          },
        });
        setErr(null);
      }
      try {
        const response = await axios.get(`/config/waf/${siteUid}/crs_rule/${ruleID}`);
        dispatch({
          type: SELECT_SD_SIG_RULE,
          payload: {
            curSdSigRule: normalizeRuleGroup(response.data),
          },
        });
      } catch (err) {
        dispatch({
          type: SELECT_SD_SIG_RULE,
          payload: {
            curSdSigRule: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr]
  );

  const configCrsSecRule = useCallback(
    async (siteUid, value) => {
      try {
        await axios.patch(`/config/waf/${siteUid}/crs_sec_rule/${value.sec_rule_id}`, {
          rule_id: value.rule_id?.toString(),
          enabled: value.enable,
        });
      } catch (err) {
        setErr(err.message);
        selectCurrentRule(value.rule_id, siteUid, false);
      }
    },
    [setErr, selectCurrentRule]
  );

  const getCrsSecRule = useCallback(
    async (ruleID) => {
      try {
        const response = await axios.get(`/config/rule/crssecrule/${ruleID}`);
        return normalizeSecRule(response.data);
      } catch (err) {
        setErr(err.message);
      }
    },
    [setErr]
  );

  const curruleEnableChange = useCallback(
    async (siteUid, value) => {
      try {
        await axios.patch(`/config/waf/${siteUid}/crs_rule/${value.rule_id}`, { enabled: value.enable });
      } catch (err) {
        setErr(err.message);
        selectCurrentRule(value.rule_id, siteUid, false);
      }
    },
    [setErr, selectCurrentRule]
  );

  const curSdSigRuleEnableChange = useCallback(
    async (siteUid, value) => {
      try {
        await axios.patch(`/config/waf/${siteUid}/crs_rule/${value.rule_id}`, { enabled: value.enable });
      } catch (err) {
        setErr(err.message);
        selectCurrentSdSigRule(value.rule_id, siteUid, false);
      }
    },
    [setErr, selectCurrentSdSigRule]
  );

  const getWAFConfig = useCallback(
    async (siteUid, init = false) => {
      if (init) {
        dispatch({
          type: GET_WAF_CONFIG,
          payload: {
            wafConfig: null,
          },
        });
      }
      try {
        const response = await axios.get(`/config/waf/${siteUid}`);
        const wafConfig = normalizeWafConfig(response.data);
        dispatch({
          type: GET_WAF_CONFIG,
          payload: {
            wafConfig,
          },
        });
        return wafConfig;
      } catch (err) {
        dispatch({
          type: GET_WAF_CONFIG,
          payload: {
            wafConfig: [],
          },
        });
        setErr(err.message);
        return [];
      }
    },
    [setErr]
  );

  const configWafSetting = useCallback(
    async (siteUid, name, value) => {
      try {
        let response;
        switch (name) {
          case "change_active":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              active: value.enable,
            });
            break;
          case "globalWafCascadeChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              active: value.active,
              ...(value.smart_parse_module_active !== undefined
                ? { smart_parse_module_active: value.smart_parse_module_active }
                : {}),
              ...(value.sd_sig_module_active !== undefined
                ? { sd_sig_module_active: value.sd_sig_module_active }
                : {}),
            });
            break;
          case "sigWafActionChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              waf_action_sig: value.action,
            });
            break;
          case "sdSigWafActionChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              waf_action_sd_sig: value.action,
            });
            break;
          case "customBlockPageChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              block_page: value.content,
            });
            break;
          case "set_block_page":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              block_page: value,
            });
            break;
          case "requestPayloadChange":
            response = await axios.patch(`/config/log/${siteUid}/audit_log_config`, value);
            break;
          case "useCacheChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              use_cache: value.use_cache,
            });
            break;
          case "sdSigWafActiveChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              sd_sig_module_active: value.enable,
            });
            break;
          case "smartParseWafActiveChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              smart_parse_module_active: value.enable,
            });
            break;
          case "smartParseSensitivityChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              smart_parse_sensitivity: value.sensitivity,
            });
            break;
          case "smartParseWafActionChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              waf_action_smart_parse: value.action,
            });
            break;
          case "sigWafActiveChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              signature_module_active: value.enable,
            });
            break;
          case "bulkWafToggleChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              smart_parse_module_active: value.smart_parse_module_active,
              sd_sig_module_active: value.sd_sig_module_active,
            });
            break;
          case "thresholdChange":
          case "anomalyScoringChange":
          case "anomalyScoringBlockChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              anomaly_scoring: value,
            });
            break;
          case "sigWafLevelChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              signature_waf_level: value.level,
            });
            break;
          case "sdSigChallengeKindChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              waf_challenge_kind_sd_sig: value.challenge_kind,
            });
            break;
          case "smartParseChallengeKindChange":
            response = await axios.patch(`/config/waf/${siteUid}`, {
              waf_challenge_kind_smart_parse: value.challenge_kind,
            });
            break;
          default:
            break;
        }
        if (response) {
          setWAFConfig(response.data);
        }
      } catch (err) {
        // Surface the real control-plane reason instead of swallowing it.
        // The CP returns its message in the response body (a plain string or
        // a { message } object); fall back to the axios/network message.
        const cpMsg =
          err?.response?.data?.message ||
          (typeof err?.response?.data === "string" ? err.response.data : null) ||
          err?.message ||
          "Failed to update WAF configuration";
        setErr(cpMsg);
        // Re-sync the UI to the actually persisted state (reverts the
        // optimistic toggle when the save didn't take).
        await getWAFConfig(siteUid);
        // Re-throw so callers (the WAF settings modals) stop reporting a false
        // "saved successfully" and can show the specific failure reason.
        throw new Error(cpMsg);
      }
    },
    [setErr, setWAFConfig, getWAFConfig]
  );

  const getExceptions = useCallback(
    async (siteUid) => {
      dispatch({
        type: GET_ALL_EXCEPTION,
        payload: {
          exceptions: null,
        },
      });
      try {
        const response = await axios.get(`/config/exception/${siteUid}`);
        dispatch({
          type: GET_ALL_EXCEPTION,
          payload: {
            exceptions: response.data,
          },
        });
      } catch (err) {
        dispatch({
          type: GET_ALL_EXCEPTION,
          payload: {
            exceptions: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr]
  );
  const updateException = useCallback(
    async (siteUid, exceptionID, value) => {
      try {
        await axios.patch(`/config/exception/${siteUid}/${exceptionID}`, value);
        getExceptions(siteUid);
        return { msg: "Success", status: "success" };
      } catch (err) {
        const error_msg = err.message;
        setErr(error_msg);
        return { msg: error_msg, status: "error" };
      }
    },
    [getExceptions, setErr]
  );
  const deleteException = useCallback(
    async (siteUid, value) => {
      try {
        await axios.delete(`config/exception/${siteUid}`, {
          data: value,
        });
        getExceptions(siteUid);
      } catch (err) {
        setErr(err.message);
      }
    },
    [getExceptions, setErr]
  );

  const getRulesForException = useCallback(
    async (ruleID) => {
      dispatch({
        type: GET_RULES_FOR_EXCEPTION,
        payload: {
          rulesForException: null,
        },
      });
      try {
        if (ruleID === "all") {
          const response = await axios.get("/config/rule/crssecrules");
          const normalized = Array.isArray(response.data) ? response.data.map(normalizeSecRule) : response.data;
          dispatch({
            type: GET_RULES_FOR_EXCEPTION,
            payload: {
              rulesForException: normalized,
            },
          });
        } else if ("sdall" === ruleID) {
          const response = await axios.get("/config/rule/sdsecrules");
          const normalized = Array.isArray(response.data) ? response.data.map(normalizeSecRule) : response.data;
          dispatch({
            type: GET_RULES_FOR_EXCEPTION,
            payload: {
              rulesForException: normalized,
            },
          });
        } else {
          const response = await axios.get(`/config/rule/crssecrules/${ruleID}`);
          const normalized = Array.isArray(response.data) ? response.data.map(normalizeSecRule) : response.data;
          dispatch({
            type: GET_RULES_FOR_EXCEPTION,
            payload: {
              rulesForException: normalized,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: GET_RULES_FOR_EXCEPTION,
          payload: {
            rulesForException: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr]
  );

  const getAllCrsSecRules = useCallback(async () => {
    try {
      const response = await axios.get("/config/rule/crssecrules");
      dispatch({
        type: GET_ALL_CRS_SEC_RULES,
        payload: {
          allCrsSecRules: Array.isArray(response.data) ? response.data.map(normalizeSecRule) : response.data,
        },
      });
    } catch (err) {
      setErr(err.message);
      dispatch({
        type: GET_ALL_CRS_SEC_RULES,
        payload: {
          allCrsSecRules: [],
        },
      });
    }
  }, [setErr]);

  const getAllSdSecRules = useCallback(async () => {
    try {
      const response = await axios.get("/config/rule/sdsecrules");
      dispatch({
        type: GET_ALL_SD_SEC_RULES,
        payload: {
          allSdSecRules: Array.isArray(response.data) ? response.data.map(normalizeSecRule) : response.data,
        },
      });
    } catch (err) {
      setErr(err.message);
      dispatch({
        type: GET_ALL_SD_SEC_RULES,
        payload: {
          allSdSecRules: [],
        },
      });
      return [];
    }
  }, [setErr]);

  const addNewException = useCallback(
    async (siteUid, value) => {
      try {
        await axios.post(`/config/exception/${siteUid}`, value);
        getExceptions(siteUid);
        return { msg: "Success", status: "success" };
      } catch (err) {
        setErr(err.message);
        let error_msg = err.message;
        return { msg: error_msg, status: "error" };
      }
    },
    [getExceptions, setErr]
  );

  const getCurrentException = useCallback(
    async (siteUid, exceptionID) => {
      try {
        const response = await axios.get(`/config/exception/${siteUid}/${exceptionID}`);
        return response.data;
      } catch (err) {
        setErr(err.message);
        return [];
      }
    },
    [setErr]
  );

  const saveExceptionsOrder = useCallback(
    async (siteUid, value) => {
      try {
        await axios.patch(`/config/exception/${siteUid}/set_order`, value);
        return { msg: "Success", status: "success" };
      } catch (err) {
        setErr(err.message);
        let error_msg = err.message;
        return { msg: error_msg, status: "error" };
      }
    },
    [setErr]
  );

  const getEdgeConfig = useCallback(async () => {
    try {
      const response = await axios.get("/config/waf/edge");
      return response.data;
    } catch (err) {
      setErr(err.message);
      return {};
    }
  }, [setErr]);

  return (
    <WAFConfigContext.Provider
      value={{
        ...state,
        setErr,
        clearCustomRules,
        clearExceptions,
        getCustomRules,
        createCustomRule,
        updateCustomRule,
        deleteCustomRule,
        getCustomRule,
        getRules,
        selectCurrentRule,
        getSdSigRules,
        selectCurrentSdSigRule,
        configCrsSecRule,
        getCrsSecRule,
        curruleEnableChange,
        curSdSigRuleEnableChange,
        getWAFConfig,
        configWafSetting,
        getExceptions,
        updateException,
        deleteException,
        getRulesForException,
        getAllCrsSecRules,
        getAllSdSecRules,
        addNewException,
        getCurrentException,
        saveExceptionsOrder,
        getEdgeConfig,
      }}
    >
      {children}
    </WAFConfigContext.Provider>
  );
}

export { WAFConfigContext, WAFRuleProvider };
